export default "__VITE_ASSET__3aef9571__"